module.exports = __webpack_public_path__ + "img/DSC_2737-xs.57fc8df3.png";